// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

type NumberFormatterFunctionType = (value: string | number, prefix?: string, postfix?: string) => string;
interface NumberFormatterCacheType {
    [key: string]: string;
}

const memoize = (func: NumberFormatterFunctionType) => {
    const cache: NumberFormatterCacheType = {};
    return (value: string | number, prefix?: string, postfix?: string) => {
        const key = `value-${value}`;
        if (!cache[key]) {
            cache[key] = func(value, prefix, postfix);
        }
        return cache[key];
    };
};

export const formatNumber = memoize((value: string | number, prefix?: string, postfix?: string): string => {
    if (typeof value === "undefined") {
        return "";
    }

    const commaRegex = /\B(?=(\d{3})+(?!\d))/gm;
    const commaReplacer = ",";
    const prePostRegex = /(\d+\.*\d+)/gm;
    const prefixReplacer = prefix === "$" ? "$$$1" : `${prefix || ""}$1`;
    const postfixReplacer = postfix === "$" ? "$1$$" : `$1${postfix || ""}`;

    return value
        .toString()
        .replace(prePostRegex, prefixReplacer)
        .replace(prePostRegex, postfixReplacer)
        .replace(commaRegex, commaReplacer);
});
